import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faFileDownload } from "@fortawesome/pro-regular-svg-icons";
import { downloadFile } from "src/utils/fileDownloading.ts";
import { MellanoHolzmaFileDownloadApi } from "src/api/generated/tenants/mellano/holzma/mellanoHolzmaFileDownloadApi.ts";

export const MellanoShopOrderBatchContextMenuComponents = ({
	allSelectedBatchIds,
}: {
	allSelectedBatchIds: number[];
}) => {
	return [
		<AsyncMenuButton
			key={"holzma"}
			icon={faFileDownload}
			label={"Holzma-ohjelma"}
			disabled={allSelectedBatchIds.length !== 1}
			onClick={async () => {
				if (allSelectedBatchIds[0] == null) return;

				const fileHandle = await MellanoHolzmaFileDownloadApi.downloadHolzmaFile({
					shopOrderBatchId: allSelectedBatchIds[0],
				});
				downloadFile(fileHandle);
			}}
		/>,
	];
};
